import React from 'react';

export interface HeaderLayoutProps {
	children: React.ReactNode;
	filterParams?: React.ReactNode;
	className?: string;
}

export const HeaderLayout = ({
	children,
	filterParams,
	className,
}: HeaderLayoutProps) => (
	<header className="pb-(--templates-margin-l) border-b border-(--border-subtlest)">
		<div className={className}>{children}</div>
		{filterParams}
	</header>
);
